import styled from 'styled-components';
import { palette } from 'styled-theme';

const LayoutContentStyle = styled.div`
  width: 100%;
  padding: 5px;
  background-color: #fff;
  border: none;
  border-radius: 2px;
  box-shadow: 0 0 4px rgba(76, 76, 76, 0.08);
  height: 100%;
`;

export default LayoutContentStyle;
